export const APP = 'APP';
export const APP_LOGIN = 'APP_LOGIN';
export const APP_LOGOUT = 'APP_LOGOUT';
export const APP_REGISTRATION = 'APP_REGISTRATION';
export const APP_FORGOT_PASSWORD = 'APP_FORGOT_PASSWORD';
export const APP_RESET_PASSWORD = 'APP_RESET_PASSWORD';
export const APP_NOTIFICATION = 'APP_NOTIFICATION';
export const GET_APP_DATA = 'GET_APP_DATA';
export const APP_DATA = 'APP_DATA';
export const SET_FLOW = 'SET_FLOW';
export const SET_FLOW_INDEX = 'SET_FLOW_INDEX';
export const EDIT_APP_DATA = 'EDIT_APP_DATA';
export const APP_REFRESH_TOKEN = 'APP_REFRESH_TOKEN';
export const APP_LOADING = 'APP_LOADING';
export const APP_FLASH_MESSAGE = 'APP_FLASH_MESSAGE';
export const GET_DYOPS = 'GET_DYOPS';
export const DYOPS = 'DYOPS';
export const CHECK_ROOM = 'CHECK_ROOM';
export const GET_RESULT = 'GET_RESULT';
export const RESULT = 'RESULT';
export const GET_RESULTS = 'GET_RESULTS';
export const RESULTS = 'RESULTS';
export const RESULTS_LOADING = 'RESULTS_LOADING';
export const EDIT_RESULT = 'EDIT_RESULT';
export const GET_USER = 'GET_USER';
export const USER = 'USER';
export const USER_CHROMATIC = 'USER_CHROMATIC';
export const USER_OVAL = 'USER_OVAL';
export const GET_PATIENTS = 'GET_PATIENTS';
export const PATIENTS = 'PATIENTS';
export const PATIENTS_LOADING = 'PATIENTS_LOADING';
export const GET_PATIENT = 'GET_PATIENT';
export const PATIENT = 'PATIENT';
export const PATIENT_LOADING = 'PATIENT_LOADING';
export const RESET_PATIENT_WIZARD = 'RESET_PATIENT_WIZARD';
